import { API_TRAVEL_AUTOCOMPLETE } from '../consts/endpoints'

export const fetchAutocomplete = async (query, transport) => {
    let url = `${API_TRAVEL_AUTOCOMPLETE}?q=${encodeURIComponent(query)}`

    if (transport) {
       url += `&transport=${encodeURIComponent(transport)}`;
    }

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })

    const dataResponse = await response.json();

    if (!response.ok) {
        throw new Error(dataResponse.message || 'Autocomplete request failed');
    }

    return dataResponse;
}


